import f from "../funcs";
import $ from "jquery";


// TODO: удаляя пробел, удалять цифру слево от пробела

$.fn.onlyTime = function(params) {
    params = f.deepMixin({
        min: -1 / 0,
        max: 1 / 0,
        round: 1000
    }, params);

    return this.each(function() {
        let $input = $(this);
        // фиксим утечки памяти
        let eventKey = params.eventKey
            ? params.eventKey + " "
            : " ";

        let value = $input.val() || "";
        value = value.replace(/\s/g, "");
        $input.val(value);

        // char на другом событии не узнать,
        // при этом сохранив возможность отменить вставку символа в инпут
        $input.on("keypress" + eventKey, $.fn.onlyTime.onKeypress.bind(0, params));

        // обрабатываем пробелы, после delete/backspace и min, max
        $input.on("keyup" + eventKey, $.fn.onlyTime.onKeyup.bind(0, params));

        // мышкой можно вставить в инпут любой текст
        $input.on("blur" + eventKey, $.fn.onlyTime.onBlur.bind(0, params));
    });
};

$.fn.onlyTime.onKeypress = function(params, e) {
    let char = getChar(e);

    if ( !char ) { // Если ввели не символ, продолжать бессмысленно
        return;
    }
    let input = e.target;
    let $input = $(input);
    e.preventDefault();

    let value = input.value || "";
    let offset = input.selectionStart;
    let newValue = value;

    // буква и другая дичь
    if ( !/\d/.test(char) ) {
        return;
    }

    newValue = newValue.split("");
    newValue[ offset ] = char;
    newValue = newValue.join("");
    offset++;

    // skip :
    if ( offset == 2 ) {
        offset++;
    }

    newValue = formatToTime(newValue);

    input.value = newValue;
    input.setSelectionRange(offset, offset);

    if ( newValue != value ) {
        $input.trigger("change", e);
    }
};

$.fn.onlyTime.onKeyup = function(params, e) {
    // delete 46
    // backspace 8
    // ctrl+v
    if ( e.keyCode != 46 && e.keyCode != 8 && e.keyCode != 86 ) {
        return;
    }

    let input = e.target;
    let $input = $(input);

    let value = input.value || "";
    if ( value === "" ) {
        return;
    }

    let offset = input.selectionStart;
    let newValue = value + "";

    newValue = formatToTime(newValue);

    if ( newValue != value ) {
        input.value = newValue;
        input.setSelectionRange(offset, offset);
        $input.trigger("change", e);
    }
};

$.fn.onlyTime.onBlur = function(params, e) {
    let input = e.target;
    let $input = $(input);

    let value = input.value || "";
    if ( value === "" ) {
        return;
    }

    let newValue = formatToTime(value);

    if ( newValue != value ) {
        input.value = newValue;
        $input.trigger("change", e);
    }
};

function formatToTime(text) {
    text = text.trim();
    if ( text === "" ) {
        return text;
    }


    text = text.replace(/[^\d:]/g, "");

    // когда пустой инпут и вводишь первый символ
    if ( /^\d$/.test(text) ) {
        text = text + "0:00";
    }


    let hours = +text.split(":")[0];
    let minutes = +text.split(":")[1];

    if ( f.isNaN(hours) ) {
        hours = 0;
    }

    if ( f.isNaN(minutes) ) {
        minutes = 0;
    }

    if ( hours >= 24 ) {
        hours = 23;
    }

    if ( minutes >= 60 ) {
        minutes = 59;
    }

    // cast to text
    if ( hours < 10 ) {
        hours = "0" + hours;
    } else {
        hours = hours + "";
    }

    // cast to text
    if ( minutes < 10 ) {
        minutes = "0" + minutes;
    } else {
        minutes = minutes + "";
    }

    return hours + ":" + minutes;
}

// https://learn.javascript.ru/keyboard-events
function getChar(event) {

    //сочетания системных клавиш, кроме сочетаний с shift не являются валидными символами
    if ( event.ctrlKey || event.altKey ) {
        return null;
    }

    if ( event.which == null ) {
        if ( event.keyCode < 32 ) return null;
        return String.fromCharCode(event.keyCode); // IE
    }

    if ( event.which !== 0 && event.charCode !== 0 ) {
        if ( event.which < 32 ) return null;
        return String.fromCharCode(event.which); // остальные
    }

    return null; // специальная клавиша
}

export default $.fn.onlyTime;
